<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="chapter-number---IVP sigil_not_in_toc" id="_idParaDest-6"><a id="_idTextAnchor064"></a><a id="_idTextAnchor065"></a><span class="pagebreak" id="page7" title="7"></span></h2>
<h2 class="chapter-title---IVP" id="_idParaDest-7"><a id="_idTextAnchor066"></a>Contents</h2>
<div>
<div id="_idContainer005">
<p class="veryfirst"><a href="#/Text/acknowledgements#_idTextAnchor075">Acknowledgments</a></p>
<p class="firstleft"><a href="#/Text/ch1#_idTextAnchor078">1 Five Images of Christ in the Postapostolic Age</a></p>
<p class="firstleft"><a href="#/Text/ch2#_idTextAnchor187">2 Christ as Angel: Angel Adoptionism</a></p>
<p class="firstleft"><span href="#/Text/ch3#_idTextAnchor264" title="Link target outside of Sample">3 Christ as Prophet: Spirit Adoptionism</span></p>
<p class="firstleft"><span href="#/Text/ch4#_idTextAnchor359" title="Link target outside of Sample">4 Christ as Phantom: Docetism and Docetic Gnosticism</span></p>
<p class="firstleft"><span href="#/Text/ch5#_idTextAnchor535" title="Link target outside of Sample">5 Christ as Cosmic Mind: Hybrid Gnosticism</span></p>
<p class="firstleft"><span href="#/Text/ch6#_idTextAnchor680" title="Link target outside of Sample">6 Christ as Word: Logos Christology</span></p>
<p class="firstleft"><span href="#/Text/ch7#_idTextAnchor846" title="Link target outside of Sample">7 What, Then, Is Orthodoxy?</span></p>
<p class="firstleft"><span href="#/Text/ch7#page129" title="Link target outside of Sample">Chart: Christology Continuum</span></p>
<p class="firstleft"><span href="#/Text/notes" title="Link target outside of Sample">Notes</span></p>
<p class="firstleft"><span href="#/Text/subjectindex#_idTextAnchor1022" title="Link target outside of Sample">Subject Index</span></p>
<p class="firstleft"><span href="#/Text/scriptureindex#_idTextAnchor1023" title="Link target outside of Sample">Scripture Index</span></p>
<p class="firstleft"><span href="#/Text/praise#_idTextAnchor1024" title="Link target outside of Sample">Praise for <i>The Earliest Christologies</i></span></p>
<p class="firstleft"><span href="#/Text/author#_idTextAnchor1025" title="Link target outside of Sample">About the Author</span></p>
<p class="firstleft"><span href="#/Text/otherbooks#_idTextAnchor1026" title="Link target outside of Sample">Other Books by James Papandrea</span></p>
<p class="firstleft"><span href="#/Text/moreIVP#_idTextAnchor1027" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
<p class="firstleft"><span href="#/Text/copyright" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
<p class="body"><a id="_idTextAnchor067"></a><a id="_idTextAnchor068"></a><a id="_idTextAnchor069"></a><a id="_idTextAnchor070"></a><span class="pagebreak" id="page8" title="8"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?34df6688